<template>
  <div class="delivery">
    <div class="banner"></div>

    <div :class="this.isMobile.value ? 'profile-mobile' : 'profile'">
      <div class="profile-header">
        <div class="profile-header__title">
          <h2>我的报价</h2>
        </div>
      </div>

      <div class="resumeForm" v-if="!open">
        <!-- 基本信息 -->
        <div class="resumeViewSection">
            <el-table
                :data="tableData"
                @row-click="handleDetail"
                style="width: 100%">
              <el-table-column label="询价标题" align="center" prop="title" :show-overflow-tooltip="true" />
<!--              <el-table-column label="询价内容" align="center" prop="content" />-->
              <el-table-column label="报价人" align="center" prop="fullName" />
              <el-table-column label="报价日期" align="center" prop="createTime" />
<!--              <el-table-column label="报价人身份证号" align="center" prop="idCard" />-->
<!--              <el-table-column label="报价状态" align="center" prop="deliveryStatusName" />-->
<!--              <el-table-column label="公司法人" align="center" prop="legalName" />-->
<!--              <el-table-column label="公司法人身份证号" align="center" prop="legalIdCard" />-->
<!--              <el-table-column label="公司名称" align="center" prop="companyName" />-->
<!--              <el-table-column label="操作" align="center" class-name="small-padding fixed-width">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-button-->
<!--                      size="mini"-->
<!--                      type="text"-->
<!--                      icon="el-icon-view"-->
<!--                      @click="handleDetail(scope.row)"-->
<!--                  >详情</el-button>-->
<!--                  <el-button-->
<!--                      size="mini"-->
<!--                      type="text"-->
<!--                      icon="el-icon-edit"-->
<!--                      v-if="scope.row.deliveryStatus === 0 && scope.row.process === 0"-->
<!--                      @click="handleCancelDelivery(scope.row)"-->
<!--                  >撤回</el-button>-->
<!--                </template>-->
<!--              </el-table-column>-->
            </el-table>
        </div>
      </div>
    </div>
    <div :title="title" v-if="open" append-to-body>
      <div class="wrap detail-wrap">
        <div class="back-list" @click="cancel"><<返回</div>
      <el-form ref="form" :model="form">
        <div class="detail-line title-line">
          <div class="detail-lable">询价标题：</div>
          <div class="detail-value">{{form.title}}</div>
        </div>
        <div class="detail-line">
          <div class="detail-lable">询价内容：</div>
          <div class="detail-value">{{form.content}}</div>
        </div>
        <div class="detail-line">
          <div class="detail-lable">报价人：</div>
          <div class="detail-value">{{form.fullName}}</div>
        </div>
        <div class="detail-line">
          <div class="detail-lable">报价人身份证号：</div>
          <div class="detail-value">{{form.idCard}}</div>
        </div>
        <div class="detail-line">
          <div class="detail-lable">公司法人：</div>
          <div class="detail-value">{{form.legalName}}</div>
        </div>
        <div class="detail-line">
          <div class="detail-lable">公司法人身份证号：</div>
          <div class="detail-value">{{form.legalIdCard}}</div>
        </div>
        <div class="detail-line">
          <div class="detail-lable">公司名称：</div>
          <div class="detail-value">{{form.companyName}}</div>
        </div>
        <div class="detail-line">
          <div class="detail-lable">报价清单：</div>
          <div class="detail-value"><el-link type='primary' @click="listing(form.requireId)">点击查看</el-link></div>
        </div>
        <el-form-item label="询价文件" prop="enquiryFileList">
          <el-upload
            ref="fileUpload"
            :limit="10"
            accept="doc,docx,xls,xlsx,ppt,zip,rar,pdf,jpg,png,jpeg"
            multiple
            :on-exceed="fileLimitCallback"
            :action="upload.url"
            :headers="upload.headers"
            :file-list="enquiryFileList"
            :on-progress="handleFileUploadProgress"
            :before-upload="onBeforeUpload"
            :on-change="handleFileChange"
            :on-success="
                  (response, file, fileList) =>
                    uploadFileSuccess(response, file, fileList)
                "
            :on-error="handleFileError"
            :on-preview="handlePreview"
            :on-remove="
                  (file, fileList) => removeFileSuccess(file, fileList)
                "
            :auto-upload="false"
            disabled
          >
          </el-upload>
        </el-form-item>
        <el-form-item label="报价文件" prop="quoteFileList">
          <el-upload
            ref="fileUpload2"
            :limit="10"
            accept="doc,docx,xls,xlsx,ppt,zip,rar,pdf,jpg,png,jpeg"
            multiple
            :on-exceed="fileLimitCallback2"
            :action="upload.url"
            :headers="upload.headers"
            :file-list="quoteFileList"
            :on-progress="handleFileUploadProgress2"
            :before-upload="onBeforeUpload2"
            :on-change="handleFileChange2"
            :on-success="
                  (response, file, fileList) =>
                    uploadFileSuccess2(response, file, fileList)
                "
            :on-error="handleFileError2"
            :on-preview="handlePreview2"
            :on-remove="
                  (file, fileList) => removeFileSuccess2(file, fileList)
                "
            :auto-upload="false"
            :disabled="disabled"
          >
            <el-button slot="trigger" size="small" type="primary" v-if="!disabled"
            >选取文件</el-button
            >
            <el-button
              style="margin-left: 10px"
              size="small"
              type="success"
              :loading="upload.isUploading"
              @click="submitUpload2()"
              v-if="!disabled"
            >上传</el-button
            >
            <div slot="tip" class="el-upload__tip" v-if="!disabled">文件不超过20M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel">返 回</el-button>
      </div>
      </div>
    </div>
  </div>
</template>
<script>

import {state} from "@/store";
import { getToken } from "@/utils/auth";
import { listSubmitedEnquiry, getSubmitedEnquiry, delSubmitedEnquiry, addSubmitedEnquiry, updateSubmitedEnquiry } from "@/api/purchase/submitedEnquiry";

export default {
  name: "delivery",
  data() {
    return {
      tableData: [],
      open: false,
      openReply: false,
      form: {},
      replyForm: {},
      messageList: [],
      title: "",
      processStatus: "success",
      // 遮罩层
      loading: true,
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: "Bearer " + getToken() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/api/purchase/file/upload",
        // 上传的文件列表
        fileList: [],
      },
      enquiryFileList: [],
      quoteFileList: [],
      disabled: true
    };
  },
  computed: {
  },
  methods: {
    listing(applyId){
      console.log(34455)
      console.log(applyId)
      console.log(this.form.requireId)
      this.$router.push({name:'enquiryListingDetail',query: {id:applyId, canUpload: false}})
    },
    fetchList() {
      if (!state.isLogin) {
        this.$router.push("/user");
        return;
      }
      this.loading = true;

      // return this.request
      //     .get("/api/purchase/submitedEnquiry/list", {
      //       idCard: state.userInfo.user.idCard
      //     })
      //     .then(response => {
      //       this.tableData = response.rows;
      //       this.loading = false;
      //     })
      //     .catch(() => {
      //       this.loading = false;
      //     });

      listSubmitedEnquiry({
        idCard: state.userInfo.user.idCard
      }).then(response => {
        if(response.rows){
          for (let i = 0; i < response.rows.length; i++) {
            response.rows[i].createTime = response.rows[i].createTime.split(/\s+/)[0];
          }
        }
        this.tableData = response.rows;
        this.loading = false;
      });

    },
    fetchMessage() {
      if (!state.isLogin) {
        this.$router.push("/user");
        return;
      }

      this.request
          .post("/zpPersonalBusiness/messageList", {
            deliveryUuid: this.form.uuid,
          })
          .then(res => {
            this.messageList = res.rows;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    handleDetail(row) {
      this.loading = true;
      this.reset();
      this.request
          .get("/api/purchase/submitedEnquiry/" + row.id, {
          })
          .then(res => {
            this.form = res.data;
            this.form.title = row.title;
            this.form.content = row.content;
            this.form.fullName = row.fullName;
            this.quoteFileList = res.data.quoteFileList;
            this.enquiryFileList = res.data.enquiryFileList;
            this.form.legalName = row.legalName;
            this.form.legalIdCard = row.legalIdCard;
            this.form.companyName = row.companyName;
            this.form.publicTime = this.form.updateTime ? this.form.updateTime.split(/\s+/)[0] : this.form.createTime.split(/\s+/)[0];
            // this.getProcessStatus();
            this.loading = false;
            this.open = true;
            this.title = "报价详情";
            // this.fetchMessage();
            console.log(998877766)
            console.log(this.form)
          })
          .catch(() => {
            this.loading = false;
          });
    },
    handleCancelDelivery(row) {
      let that = this;
      if (!state.isLogin) {
        this.$router.push("/user");
        return;
      }
      this.$confirm('确认撤回投递?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function() {
        that.submitCancelDelivery(row);
      });
    },
    reply(row) {
      this.loading = true;
      this.resetReply();
      this.replyForm = row;
      this.openReply = true;
      this.title = "回复";
    },
    submitCancelDelivery(row){
      if (!state.isLogin) {
        this.$router.push("/user");
        return;
      }
      this.request
          .post("/zpPersonalBusiness/cancelDelivery", {
            id: row.id,
            version: row.version,
            updateBy: state.userInfo.user.userName,
            deliveryStatus: 1,
          })
          .then(res => {
            this.fetchList();
            this.$message.success("撤回成功");
          })
          .catch(() => {
            this.loading = false;
          });
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        idCard: null,
        requireUuid: null,
        process: null,
        status: null,
        regulate: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        version: null,
        uuid: null,
        postName: null,
        adjustPostId: null,
        adjustPostName: null,
        approvalRemark: null,
      };
      // this.resetForm("form");
    },
    // 表单重置
    resetReply() {
      this.replyForm = {
        id: null,
        deliveryUuid: null,
        processName: null,
        process: null,
        reply: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        version: null,
        uuid: null,
        approvalRemark: null,
        approvalRemarkTime: null,
      };
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    cancelReply() {
      this.openReply = false;
      this.resetReply();
    },
    /** 提交按钮 */
    submitForm() {
      if (!state.isLogin) {
        this.$router.push("/login");
        return;
      }
      this.loading = true;
      this.request
          .post("/zpPersonalBusiness/reply", {
            id: this.replyForm.id,
            reply: this.replyForm.reply,
          })
          .then(res => {
            this.$message.success("回复成功");
            this.cancelReply();
            this.fetchMessage();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    getProcessStatus() {
      if (this.form.status === 1) {
        this.processStatus = 'success';
      } else if (this.form.status === 2 || this.form.status === 3) {
        this.processStatus = 'error';
      } else {
        this.processStatus = 'process';
      }
    },

    // 文件超出个数限制时的钩子函数
    fileLimitCallback(files, fileList) {
      this.$message.warning(`当前限制最多选择 10 个文件`);
    },
    onBeforeUpload(file) {
      const isLt200M = file.size / 1024 / 1024 < 20;
      if (!isLt200M) {
        this.$message.error("上传文件大小不能超过 20M!");
        return false;
      }
      return true;
    },
    handleFileChange(file, fileList) {
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件超出个数限制时的钩子函数
    importExcelLimitCallbck() {
      this.$message.warning(`当前限制最多导入 1 个文件`);
    },
    // 处理附件上传
    uploadFileSuccess(response, file, fileList) {
      this.upload.isUploading = false;
      if (response != null && response.code == 200) {
        let files = [];
        fileList.forEach(function (val, index) {
          if(val.response){
            files.push(val.response.data);
          }else {
            files.push(val);
          }

        });
        this.enquiryFileList = files;
        this.$message.success("上传成功");
      } else {
        this.$message.error(response.msg);
      }
    },
    // 文件上传失败处理
    handleFileError(err, file, fileList) {
      this.upload.isUploading = false;
      this.$message.error("文件上传失败");
    },
    // 处理附件移除
    removeFileSuccess(file, fileList) {
      this.enquiryFileList = fileList;
    },
    // 文件提交处理
    submitUpload() {
      this.$refs.fileUpload.submit();
    },
    // 文件预览
    handlePreview(file) {
      window.open(file.url);
    },

    // 文件超出个数限制时的钩子函数
    fileLimitCallback2(files, fileList) {
      this.$message.warning(`当前限制最多选择 10 个文件`);
    },
    onBeforeUpload2(file) {
      const isLt200M = file.size / 1024 / 1024 < 20;
      if (!isLt200M) {
        this.$message.error("上传文件大小不能超过 200M!");
        return false;
      }
      return true;
    },
    handleFileChange2(file, fileList) {
    },
    // 文件上传中处理
    handleFileUploadProgress2(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件超出个数限制时的钩子函数
    importExcelLimitCallbck2() {
      this.$message.warning(`当前限制最多导入 1 个文件`);
    },
    // 处理附件上传
    uploadFileSuccess2(response, file, fileList) {
      this.upload.isUploading = false;
      if (response != null && response.code == 200) {
        let files = [];
        fileList.forEach(function (val, index) {
          if(val.response){
            files.push(val.response.data);
          }else {
            files.push(val);
          }

        });
        this.quoteFileList = files;
        this.$message.success("上传成功");
      } else {
        this.$message.error(response.msg);
      }
    },
    // 文件上传失败处理
    handleFileError2(err, file, fileList) {
      this.upload.isUploading = false;
      this.$message.error("文件上传失败");
    },
    // 处理附件移除
    removeFileSuccess2(file, fileList) {
      this.quoteFileList = fileList;
    },
    // 文件提交处理
    submitUpload2() {
      this.$refs.fileUpload2.submit();
    },
    // 文件预览
    handlePreview2(file) {
      window.open(file.url);
    },

  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="less" scoped>
.banner {
  // width: 1200px;
  background-image: url("//sf1-ttcdn-tos.pstatp.com/obj/ttfe/ATSX/my_resume_banner_1577084307030.jpg");
  background-size: 100% 100%;
  height: 300px;
  background-repeat: no-repeat;
}

.profile {
  width: 1100px;
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}

.profile-mobile {
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 15px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}

.wrap{
  width: 900px;
  margin: 0 auto;
  /*background-color: red;*/
}
@media(max-width:960px){
  .wrap{
    width: 100%;
    margin: 0 auto;
  }
}
.detail-wrap{
  /*padding: 20px 50px 50px 50px;*/
  /*font-size: 18px;*/
  /*!*box-shadow: 3px 5px 10px 5px #ccc;*!*/
  /*margin-top: 30px;*/
  /*background-color: #fff;*/


  margin-top: 30px;
  background: #fff;
  box-shadow: 0px 9px 20px 0px #c2c1c180;
  border-radius: 4px;
  padding: 30px;
  padding-top: 0;
}
@media(max-width:960px){
  .detail-wrap{
    padding: 20px;
    padding-top: 0;
  }
}
.back-list{
  height: 100px;
  line-height: 100px;
  color: blue;
  cursor: pointer;
}
.detail-line{
  display: flex;
  margin-bottom: 30px;
  .detail-lable{
    width: 150px;
    text-align: right;
    margin-right: 30px;
    color: #333;
  }
  @media(max-width:960px){
    .detail-lable{
      width: 80px;
    }
  }
  .detail-value{
    flex: 1;
    color: #515151;
  }
}
@media(max-width:960px){
  .banner{
    height: 210px;
  }
  .profile-header{
    margin-left: 20px !important;
  }
  .ql-editor{
    line-height: 2;
  }
  .back-list{
    height: 60px;
    line-height: 60px;
  }
  .detail-line{
    margin-bottom: 30px;
    /*flex-direction: column !important;*/

    .detail-lable{
      text-align: left;
      color: blue;
      margin-bottom: 10px;
      margin-right: 10px;
    }
    .detail-value{

    }
  }
  .detail-line.title-line{
    .detail-lable{
      display: none;
    }
    .detail-value{
      text-align: center;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-table /deep/ thead {
    color: #515151;
  }
  .el-table /deep/ td, .el-table /deep/ th{ /* css是>>> scss是deep */
    padding: 6px 0;
  }
}
</style>
